import { createSelector } from 'reselect';

import { eventMetaDataSelector } from '../../common/tracking/selectors';
import { dateFilterQuery, filtersQuery } from '../filters/selectors';
import { JOBS_SIZE } from './../../../constants';

export const jobsQuerySelector = createSelector([
  (store) => store.apps.archives.rdc.filters,
  dateFilterQuery,
  filtersQuery,
], (filtersStore, dateFilter, filters) => ({
  size: JOBS_SIZE,
  page: filtersStore.getIn(['query', 'page']) - 1,
  ...dateFilter,
  ...filters,
}));

export const jobsPagination = createSelector([
  (store) => store.apps.archives.rdc.filters,
  (store) => store.apps.archives.rdc.container,
], (filters, container) => ({
  total: Math.ceil(container.get('total') / JOBS_SIZE),
  current: filters.getIn(['query', 'page']),
  show: container.get('total') > JOBS_SIZE,
}));

export const containerSelector = createSelector([
  (store) => store.apps.archives.rdc.container,
  jobsPagination,
  eventMetaDataSelector,
], (container, pagination, eventMetaData) => ({
  initialized: container.get('initialized'),
  queryError: container.get('error'),
  jobsLoading: container.get('jobsLoading'),
  results: container.get('results'),
  pagination,
  eventMetaData: {
    ...eventMetaData,
    sku_type: 'RDC',
  },
}));
